/* istanbul ignore file */

import { keyframes } from "@chakra-ui/system";
import { getColor, mode } from "@chakra-ui/theme-tools";

const fade = (startColor, endColor) =>
  keyframes({
    from: { borderColor: startColor, background: startColor },
    to: { borderColor: endColor, background: endColor },
  });

const baseStyle = (props) => {
  const defaultStartColor = mode("rgba(27, 34, 40, 0.4)", "rgba(255, 255, 255, 0.4)")(props);
  const defaultEndColor = mode("rgba(27, 34, 40, 0.3)", "rgba(255, 255, 255, 0.3)")(props);

  const { startColor = defaultStartColor, endColor = defaultEndColor, speed, theme } = props;

  const start = getColor(theme, startColor);
  const end = getColor(theme, endColor);

  return {
    opacity: 0.7,
    borderRadius: "2px",
    borderColor: start,
    background: end,
    animation: `${speed}s linear infinite alternate ${fade(start, end)}`,
  };
};

const skeleton = {
  baseStyle,
};

export default skeleton;
